




















import mixins from 'vue-typed-mixins'
import * as qs from 'qs'
import UserActionMixin from '@/mixins/UserActionMixin'

export default mixins(UserActionMixin).extend({
  name: 'Gift',
  data() {
    return {
      gifts: []
    }
  },
  async created() {
    try {
      const res = await this.$http.post(
        '/message.php',
        qs.stringify({
          page: 'gift_init'
        })
      )
      this.gifts = res.data.gifts
    } catch (err) {
      console.error(err)
    }
  },
  methods: {
    /**
     * ギフトを贈る
     */
    async giveGift(giftName: string, giftNo: number) {
      try {
        const buttonIndex = await this.$_confirm(
          `'${giftName}'ギフトを贈りますか?`,
          'ギフトの確認',
          ['キャンセル', '贈る']
        )
        if (!this.$_clickedConfirmOK(buttonIndex)) {
          return
        }

        const res = await this.$http.post(
          '/message.php',
          qs.stringify({
            gift: {
              other_id: this.$route.params.id,
              no: giftNo
            }
          })
        )
        if (res.data.entries.message.error) {
          const error = res.data.entries.message.error
          // TODO: エラーコード化(文字列比較だとメッセージが変わった場合、柔軟に対応できない)
          if (error.message === 'ポイント不足') {
            this.$_showPointBuyDialog(error.description, error.message)
          }
        } else {
          // message/id に遷移
          this.$router.replace({ path: `/message/${this.$route.params.id}` })
        }
      } catch (err) {
        this.$_alert('ギフトの送信に失敗')
        console.error(err)
      }
    }
  }
})
